export default __webpack_public_path__ + "static/media/thunder.d99ad9be.png";